import { waitFor } from "./waitFor"

export const runUntil = async <T>(fn: () => Promise<T | null>, attempts = 60, delay = 500): Promise<T | null> => {
  let remaining = attempts - 1

  while (true) {
    const result = await fn() // eslint-disable-line no-await-in-loop

    if (result !== null || remaining === 0) {
      return result
    }

    remaining -= 1
    await waitFor(delay) // eslint-disable-line no-await-in-loop
  }
}
